import firebase from "../services/FirebaseService";

class UserService {
	
	async getUserInfo(uid) {

		let user = {};

		try {
			const results = await firebase.firestore().collection("users").doc(uid).get();

			user.uid = uid;
			user.name = results.get("name");
			user.about = results.get("about");
			user.location = results.get("location");
			user.isStaff = await this.isUserAdmin(uid);

			return user;
		} 
		catch(error) {
			throw new Error("An error occured. Try again later.");
		}
	}

	async getName(uid) {

		let name;

		try {
			const results = await firebase.firestore().collection("users").doc(uid).get();

			name = results.get("name");

			return name;
		}
		catch(error) {
			throw new Error("An error occured. Try again later.");
		}
		finally {
		}
	}

	async isUserAdmin(uid) {

		let isAdmin = false;
		
		try {

			const results = await firebase.firestore().collection("config").where("staff", "array-contains", uid).get();
			
			if(!results.empty) {
				isAdmin = true;
			}

			
			return isAdmin;

		}
		catch(error) {
			throw new Error("There was an error retrieving admin data");
		}
	}
	async updateProfile(uid, name, location, about) {
		try {

			await firebase.firestore().collection("users").doc(uid).update({
				name: name,
				location: location,
				about: about
			})

		}
		catch(error) {
			throw error;
		}
	}
}

export default UserService;